import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-booking-subscription-activation-dialog',
    templateUrl: './booking-subscription-activation-dialog.component.html',
    styleUrls: ['./booking-subscription-activation-dialog.component.css'],
    standalone: false
})
export class BookingSubscriptionActivationDialogComponent implements OnInit {
  trialEndDate: Date = new Date(2026, 11, 31); // Diciembre 31, 2026
  monthlyPrice: number = 0;

  constructor(
    public dialogRef: MatDialogRef<BookingSubscriptionActivationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {
    if (data && data.monthlyPrice !== undefined) {
      this.monthlyPrice = data.monthlyPrice;
    }
  }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  getFormattedTrialEndDate(): string {
    return this.trialEndDate.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
}
